// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://mantlescan.xyz/address/0x2D787621f9C635ADe313126dF7615c02bff35517
export const FBTC__BTC_Exchange_Rate = '0x2D787621f9C635ADe313126dF7615c02bff35517';

// https://mantlescan.xyz/address/0x5166FC3adff16E99bb099834a1315e57C5444394
export const USDe__USD = '0x5166FC3adff16E99bb099834a1315e57C5444394';

// https://mantlescan.xyz/address/0xC5fD97adABf827e9FCC4ed936360f47080F35868
export const OUSDT__USD = '0xC5fD97adABf827e9FCC4ed936360f47080F35868';

// https://mantlescan.xyz/address/0xaDE1b9AbB98c6A542E4B49db2588a3Ec4bF7Cdf0
export const L2_Sequencer_Uptime_Status_Feed = '0xaDE1b9AbB98c6A542E4B49db2588a3Ec4bF7Cdf0';

// https://mantlescan.xyz/address/0x5bc7Cf88EB131DB18b5d7930e793095140799aD5
export const ETH__USD = '0x5bc7Cf88EB131DB18b5d7930e793095140799aD5';

// https://mantlescan.xyz/address/0x22b422CECb0D4Bd5afF3EA999b048FA17F5263bD
export const USDC__USD = '0x22b422CECb0D4Bd5afF3EA999b048FA17F5263bD';

// https://mantlescan.xyz/address/0x8A6D34330E8F61364a62899fD0a8F4C4021e3296
export const Real_GDP_Percent_Change_Annual_Rate = '0x8A6D34330E8F61364a62899fD0a8F4C4021e3296';

// https://mantlescan.xyz/address/0x5871AdBEEdAD531C68A8FD32fE86f07d6b4C645d
export const LINK__USD = '0x5871AdBEEdAD531C68A8FD32fE86f07d6b4C645d';

// https://mantlescan.xyz/address/0xE2f6c76c05985e90B043CC6ddf1D09e8BF5FAAf9
export const ynETHx__ETH_Exchange_Rate = '0xE2f6c76c05985e90B043CC6ddf1D09e8BF5FAAf9';

// https://mantlescan.xyz/address/0xB16FcAFB8378baA0a69142a325878FDCad58606A
export const Calculated_mETH__USD = '0xB16FcAFB8378baA0a69142a325878FDCad58606A';

// https://mantlescan.xyz/address/0x6352E3A925E27130317d3A0A5b0b0303e9f2fc7c
export const mETH__ETH = '0x6352E3A925E27130317d3A0A5b0b0303e9f2fc7c';

// https://mantlescan.xyz/address/0x5fc69E6bA39D9150D41B4FFBDa3Deb1b9Bd4611A
export const Real_GDP_Level = '0x5fc69E6bA39D9150D41B4FFBDa3Deb1b9Bd4611A';

// https://mantlescan.xyz/address/0x02959651ED50f9866BF39D29884dF245D03FdC51
export const Calculated_cmETH__ETH = '0x02959651ED50f9866BF39D29884dF245D03FdC51';

// https://mantlescan.xyz/address/0xdDEaeAdF319bd363120Af02fBdb1e2C5A3Ce172a
export const SYRUPUSDT__USDT_Exchange_Rate = '0xdDEaeAdF319bd363120Af02fBdb1e2C5A3Ce172a';

// https://mantlescan.xyz/address/0xA6B6A4E844126b8a44Ab6564b3A65048217cB58C
export const SYRUPUSDC__USDC_Exchange_Rate = '0xA6B6A4E844126b8a44Ab6564b3A65048217cB58C';

// https://mantlescan.xyz/address/0x80C42686a5F953d3c629cb5a35BCC86B1Ddd21e3
export const Calculated_cmETH__USD = '0x80C42686a5F953d3c629cb5a35BCC86B1Ddd21e3';

// https://mantlescan.xyz/address/0xAa7B3679db156d3773620eBce98E38Cd87544C0e
export const RSETH__ETH_Exchange_Rate = '0xAa7B3679db156d3773620eBce98E38Cd87544C0e';

// https://mantlescan.xyz/address/0x73b15e19b247263D03D7938f1356304b7B330Ff0
export const Calculated_FBTC__USD = '0x73b15e19b247263D03D7938f1356304b7B330Ff0';

// https://mantlescan.xyz/address/0x4F923DaC0871d29E6147C27Fb7f53bEf13267E31
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x4F923DaC0871d29E6147C27Fb7f53bEf13267E31';

// https://mantlescan.xyz/address/0x1D28137b7695d1Dcd122E5Bf0ce7eE92360e83b7
export const SUSDE__USDE_Exchange_Rate = '0x1D28137b7695d1Dcd122E5Bf0ce7eE92360e83b7';

// https://mantlescan.xyz/address/0x663Fa56307caa30f0C1a2d20D550E13ED85AE78d
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0x663Fa56307caa30f0C1a2d20D550E13ED85AE78d';

// https://mantlescan.xyz/address/0x7b7EAf6DBA9b1B3796CF9060517D3D0b2EBA39Fc
export const PCE_Price_Index_Level = '0x7b7EAf6DBA9b1B3796CF9060517D3D0b2EBA39Fc';

// https://mantlescan.xyz/address/0xaAA8b026379A2C670330F94d0e35dd5550c26EC1
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0xaAA8b026379A2C670330F94d0e35dd5550c26EC1';

// https://mantlescan.xyz/address/0x6d5110FB8F6a65c46B89a64C9ac7E3542D31AbA3
export const sUSDe__USD = '0x6d5110FB8F6a65c46B89a64C9ac7E3542D31AbA3';

// https://mantlescan.xyz/address/0x7db2275279F52D0914A481e14c4Ce5a59705A25b
export const BTC__USD = '0x7db2275279F52D0914A481e14c4Ce5a59705A25b';

// https://mantlescan.xyz/address/0x01dd982820B7c25e2A9C77BDd3bC0eDA90298A2F
export const USD1__USD = '0x01dd982820B7c25e2A9C77BDd3bC0eDA90298A2F';

// https://mantlescan.xyz/address/0xD97F20bEbeD74e8144134C4b148fE93417dd0F96
export const MNT__USD = '0xD97F20bEbeD74e8144134C4b148fE93417dd0F96';

// https://mantlescan.xyz/address/0xd86048D5e4fe96157CE03Ae519A9045bEDaa6551
export const USDT__USD = '0xd86048D5e4fe96157CE03Ae519A9045bEDaa6551';

export const CHAIN_ID = 5000;
